/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import { mergeEdits } from 'state/utils';


export default (state, id) => {
    const logs = get(state, ['locations', 'edits', id], null);

    if (!logs) {
        return null;
    }

    return mergeEdits(...logs);
};